import React from 'react';
import Modal from './Modal';
import Button from './Button';

export default function ConfirmDialog({
  isOpen, onConfirm, onCancel, title = 'Confirm', message, extra,
  confirmLabel = 'Confirm', confirmVariant = 'danger', loading,
  hideConfirm = false, cancelLabel = 'Cancel',
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading}>{cancelLabel}</Button>
          {!hideConfirm && (
            <Button variant={confirmVariant} onClick={onConfirm} loading={loading}>{confirmLabel}</Button>
          )}
        </>
      }
    >
      <p className="text-sm text-gray-600">{message}</p>
      {extra ? <div className="mt-3">{extra}</div> : null}
    </Modal>
  );
}
